import { gql } from '@apollo/client'
import { Modal } from '@plusplusminus/plusplusdash'
import { useDeleteAccountGroupMutation } from 'generated'
import toast from 'react-hot-toast'
import Button from 'components/Button'

type DeleteAccountGroupProps = {
  id?: string
  name?: string
  isOpen: boolean
  onClose: () => void
  onDelete: () => void
}

export default function DeleteAccountGroupModal(props: DeleteAccountGroupProps): JSX.Element {
  const [deleteAccountGroup, { loading }] = useDeleteAccountGroupMutation({
    onCompleted: () => {
      toast.success('Deleted audience segment')
      props.onDelete()
    },
    onError: (error) => {
      console.log({ error })
      toast.error('Error. could not delete audience segment')
    }
  })
  const deleteAccGroup = () => {
    props.id && deleteAccountGroup({ variables: { id: props.id } })
  }

  return (
    <Modal isOpen={props.isOpen} size="sm" onClose={props.onClose}>
      <Modal.Title>Are you sure you want to delete the "{props.name}" audience segment?</Modal.Title>
      <Modal.Description>
        <div className="flex justify-end gap-2 mt-8">
          <Button variant="plain" colorScheme="red" onClick={props.onClose}>
            Cancel
          </Button>
          <Button variant="primary" colorScheme="red" onClick={deleteAccGroup} isDisabled={loading} isLoading={loading}>
            Yes, Delete
          </Button>
        </div>
      </Modal.Description>
    </Modal>
  )
}

DeleteAccountGroupModal.mutation = gql`
  mutation DeleteAccountGroup($id: ID!) {
    deleteOneAccountGroup(input: { id: $id }) {
      id
    }
  }
`
